// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../sharedmodules/action-creators/busy-counter';
import actions from '../../../../sharedmodules/actions-list';
import { getDetails } from '../../shared/repositories';
import { readLatestPerUnitMeasurements } from '../../shared/action-creators/latest-per-unit-measurements';

export const updateProduct = (getAccessToken, pin) => async (dispatch) => {

    dispatch(busyCounter.increaseBusyCounter());

    try {

        const data = await getDetails(getAccessToken, pin);

        dispatch({
            data,
            type: actions.UPDATE_NEW_TRANSFER_PRODUCT_SUCCESS,

        });

        if (data.otherUnitRequired === 'N') {

            readLatestPerUnitMeasurements(data.pin)(dispatch);

        }

    } catch (error) {

        dispatch({
            error,
            type: actions.UPDATE_DETAILS_ERROR,
        });

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};

export const resetProductDetails = () => ({
    type: actions.RESET_PRODUCT_CUSTOMER_DETAILS,
});
